<template>
  <div class="admin-dashboard">
    <div class="dashboard-nav">
      <span><i class="fa fa-home"></i>{{ $t('adminIndex.home') }}</span>
      <span class="nav-sep">/</span>
      <span class="nav-active">{{ $t('adminIndex.platformData') }}</span>
    </div>
    <div class="stat-cards">
      <div v-for="(item, index) in adminIndexInfo.datas" :key="index" class="stat-card" :style="{ background: cardGradients[index % cardGradients.length] }">
        <div class="stat-value">{{ item.value }}</div>
        <div class="stat-name">{{ item.name }}</div>
      </div>
    </div>
    <el-row :gutter="16" class="chart-row">
      <el-col :span="12">
        <div class="chart-card" id="communityFeeCharts"></div>
      </el-col>
      <el-col :span="12">
        <div class="chart-card" id="communityRepairCharts"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import {
  queryAdminCount,
  queryCommunityFee,
  queryCommunityRepair
} from '@/api/user/adminIndexApi'

export default {
  name: 'AdminIndex',
  data() {
    return {
      adminIndexInfo: {
        hostCount: 0,
        datas: [],
        action: ''
      },
      cardGradients: [
        'linear-gradient(135deg, #3B82F6 0%, #60A5FA 100%)',
        'linear-gradient(135deg, #10B981 0%, #34D399 100%)',
        'linear-gradient(135deg, #F59E0B 0%, #FBBF24 100%)',
        'linear-gradient(135deg, #8B5CF6 0%, #A78BFA 100%)',
        'linear-gradient(135deg, #EF4444 0%, #F87171 100%)',
        'linear-gradient(135deg, #06B6D4 0%, #22D3EE 100%)'
      ]
    }
  },
  mounted() {
    this._loadViewAdminData()
    this._loadCommunityFee()
    this._loadCommunityRepair()
  },
  methods: {
    async _loadViewAdminData() {
      try {
        const res = await queryAdminCount({ platform: 'admin' })
        const filteredData = res.data.filter(item =>
          !item.name.includes('商家') &&
          !item.name.includes('店铺') &&
          !item.name.includes('商铺')
        )
        this.adminIndexInfo.datas = filteredData
      } catch (error) {
        console.error('Failed to load admin data:', error)
      }
    },
    async _loadCommunityFee() {
      try {
        const res = await queryCommunityFee({ platform: 'admin' })
        this._initAdminIndexCommunityFeeCharts(res.data)
      } catch (error) {
        console.error('Failed to load community fee data:', error)
      }
    },
    _initAdminIndexCommunityFeeCharts(_data) {
      const dom = document.getElementById('communityFeeCharts')
      const _source = [['product', this.$t('adminIndex.paymentCount'), this.$t('adminIndex.paymentAmount')]]

      _data.forEach(item => {
        _source.push([
          item.communityName,
          item.count,
          item.receivedAmount
        ])
      })

      const myChart = echarts.init(dom)
      const option = {
        legend: {},
        tooltip: { trigger: 'axis', backgroundColor: 'rgba(15,23,42,0.9)', borderColor: 'transparent', textStyle: { color: '#fff' } },
        title: {
          show: true,
          text: this.$t('adminIndex.communityFeeStats'),
          textStyle: { fontSize: 14, fontWeight: 600, color: '#334155' }
        },
        grid: { top: 50, bottom: 30, left: 50, right: 20 },
        color: ['#60A5FA', '#34D399'],
        dataset: { source: _source },
        xAxis: { type: 'category', axisLine: { lineStyle: { color: '#e2e8f0' } }, axisLabel: { color: '#94a3b8' } },
        yAxis: { axisLine: { show: false }, axisLabel: { color: '#94a3b8' }, splitLine: { lineStyle: { color: '#f1f5f9' } } },
        series: [
          { type: 'bar', barWidth: 20, itemStyle: { borderRadius: [4, 4, 0, 0] } },
          { type: 'bar', barWidth: 20, itemStyle: { borderRadius: [4, 4, 0, 0] } }
        ]
      }

      if (option && typeof option === 'object') {
        myChart.setOption(option, true)
      }
    },
    async _loadCommunityRepair() {
      try {
        const res = await queryCommunityRepair({ platform: 'admin' })
        this._initAdminIndexCommunityRepairCharts(res.data)
      } catch (error) {
        console.error('Failed to load community repair data:', error)
      }
    },
    _initAdminIndexCommunityRepairCharts(_data) {
      const dom = document.getElementById('communityRepairCharts')
      const _source = [['product', this.$t('adminIndex.repairCount')]]

      _data.forEach(item => {
        _source.push([
          item.communityName,
          item.count
        ])
      })

      const myChart = echarts.init(dom)
      const option = {
        legend: {},
        tooltip: { trigger: 'axis', backgroundColor: 'rgba(15,23,42,0.9)', borderColor: 'transparent', textStyle: { color: '#fff' } },
        title: {
          show: true,
          text: this.$t('adminIndex.communityRepairStats'),
          textStyle: { fontSize: 14, fontWeight: 600, color: '#334155' }
        },
        grid: { top: 50, bottom: 30, left: 50, right: 20 },
        color: ['#60A5FA'],
        dataset: { source: _source },
        xAxis: { type: 'category', axisLine: { lineStyle: { color: '#e2e8f0' } }, axisLabel: { color: '#94a3b8' } },
        yAxis: { axisLine: { show: false }, axisLabel: { color: '#94a3b8' }, splitLine: { lineStyle: { color: '#f1f5f9' } } },
        series: [
          { type: 'bar', barWidth: 24, itemStyle: { borderRadius: [4, 4, 0, 0] } }
        ]
      }

      if (option && typeof option === 'object') {
        myChart.setOption(option, true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-dashboard {
  padding: 0 4px;
}

.dashboard-nav {
  padding: 8px 4px 16px;
  font-size: 14px;
  color: #94a3b8;

  i {
    margin-right: 4px;
    color: #3B82F6;
  }
}

.nav-sep {
  margin: 0 6px;
  color: #cbd5e1;
}

.nav-active {
  color: #334155;
  font-weight: 500;
}

.stat-cards {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.stat-card {
  flex: 1;
  min-width: 140px;
  padding: 20px;
  border-radius: 12px;
  color: #ffffff;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  }
}

.stat-value {
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
}

.stat-name {
  font-size: 13px;
  opacity: 0.85;
  margin-top: 6px;
}

.chart-row {
  margin-bottom: 16px;
}

.chart-card {
  height: 400px;
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 4px 12px rgba(0, 0, 0, 0.03);
}
</style>
